import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
    ORDER_STATUS_ESTIMATED_DELIVERY,
    ORDER_STATUS_ESTIMATED_DROP, ORDER_STATUS_IN_TRANSIT,
    ORDER_STATUS_SHIPPED
} from 'Component/MyAccountOrderTimeline/MyAccountOrderTimeline.config';
import { OrderType } from 'Type/Order.type';
import { formatOrderTimeline } from 'Util/Orders/Orders';

import MyAccountOrderTimeline from './MyAccountOrderTimeline.component';

/** @namespace PeggysagePwa/Component/MyAccountOrderTimeline/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    currentStoreCode: state.ConfigReducer.code
});

/** @namespace PeggysagePwa/Component/MyAccountOrderTimeline/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/MyAccountOrderTimeline/Container */
export class MyAccountOrderTimelineContainer extends PureComponent {
    static propTypes = {
        currentStoreCode: PropTypes.string,
        order: OrderType.isRequired
    };

    static defaultProps = {
        currentStoreCode: 'fr-FR'
    };

    state = {
        timeline: [],
        trackingStepStatus: ''
    };

    containerFunctions = {
        // getData: this.getData.bind(this)
    };

    componentDidMount() {
        this.updateTimeline();
    }

    componentDidUpdate(prevProps) {
        const { order } = this.props;
        const { order: prevOrder } = prevProps;

        if (order !== prevOrder) {
            this.updateTimeline();
        }
    }

    containerProps() {
        const { currentStoreCode, order } = this.props;
        const { timeline, trackingStepStatus } = this.state;

        return {
            currentStoreCode,
            order,
            timeline,
            trackingStepStatus
        };
    }

    getTrackingStepStatus(timeline) {
        const statusesOrdered = [
            ORDER_STATUS_ESTIMATED_DROP,
            ORDER_STATUS_ESTIMATED_DELIVERY,
            ORDER_STATUS_IN_TRANSIT,
            ORDER_STATUS_SHIPPED
        ];

        const trackingStepStatus = statusesOrdered.find(
            (status) => timeline.find((step) => step.status === status)
        );

        return typeof trackingStepStatus !== 'undefined' ? trackingStepStatus : timeline.slice(-1)[0].status;
    }

    updateTimeline() {
        const { order: { timeline: sourceTimeline } } = this.props;

        const timeline = formatOrderTimeline(sourceTimeline);

        this.setState({
            timeline,
            trackingStepStatus: this.getTrackingStepStatus(timeline)
        });
    }

    render() {
        return (
            <MyAccountOrderTimeline
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOrderTimelineContainer);
